// CommentSection.jsx
import React, { useState, useEffect } from "react";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { Panel } from "primereact/panel";
import { API } from "./App";
import { getAuthHeader } from "./AuthRoute";
import { Badge } from "primereact/badge";

export default function Comments({ sondageId }) {
  const [collapsed, setCollapsed] = useState(true);
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");

  useEffect(() => {
    if (!sondageId) return;
    fetch(`${API()}/sondages/${sondageId}`, {
      headers: {
        Authorization: getAuthHeader(),
      },
    })
      .then((r) => r.json())
      .then((data) => setComments(data.comments || []));
  }, [sondageId]);

  function submitComment() {
    if (!newComment.trim()) return;

    fetch(`${API()}/sondages/${sondageId}/new-comment`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getAuthHeader(),
      },
      body: JSON.stringify({ comment: newComment }),
    })
      .then((res) => res.json())
      .then(() => {
        setComments((prev) => [
          ...prev,
          {
            comment: newComment,
            created_by: "you",
            created_at: new Date().toISOString(),
          },
        ]);
        setNewComment("");
      });
  }

  return (
    <Panel
      toggleable
      collapsed={collapsed}
      onToggle={(e) => setCollapsed(e.value)}
      header={
        <div className="flex justify-between items-center">
          <span>Commentaires</span>{" "}
          <Badge value={comments.length} severity="warning" />
        </div>
      }
    >
      <div className="mb-2">
        <InputTextarea
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
          rows={1}
          cols={25}
          placeholder="Ajouter un commentaire..."
          autoResize
        />
        <Button label="Envoyer" className="mt-1" onClick={submitComment} />
      </div>

      <ul style={{ height: "150px", overflowY: "auto" }}>
        {comments.map((c, i) => (
          <li key={i}>
            <strong>{c.created_by}</strong> —{" "}
            {new Date(c.created_at).toLocaleString()} <br />
            {c.comment}
          </li>
        ))}
      </ul>
    </Panel>
  );
}
